import type { FaireProductEntity } from "../../entity_types/product";

export const p_2rsqm8q8hx: FaireProductEntity = {
  token: "p_2rsqm8q8hx",
  type: "product",
  name: "Active Peptides Cortisol | Capsule (30 Servings)",
  brandToken: "b_at5l4qlr",
  brandName: "Ancient Nutrition",
  imageUrl:
    "https://cdn.faire.com/fastly/f1b1faceec3d0b53e7aee3f69ec43e42c0a18910b42db4d056dc4b3ef4a758d8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/56d5c41a0bfb2d827c4cb9d7c95fa0401d5485d310cf41ae47cffb547f92c63d.jpeg",
    "https://cdn.faire.com/fastly/d1c03a7ae7cad08653a62e3e1c55bb7cef60290182cba82fd85f66a4c95789c0.jpeg",
    "https://cdn.faire.com/fastly/7bf1794a841078ad375ee0cdc6d34a8d6eeb8857978da6f67a3643cc23ccf0e3.jpeg",
    "https://cdn.faire.com/fastly/c7e9f63d5afb986e20726781dd5bb93b533605d18ad1df4bff40653ebb851f8d.jpeg",
    "https://cdn.faire.com/fastly/b635c9abed262c04fd2a06c1e4bc8391811bdba5b5511e4812ee45367cda1680.jpeg",
    "https://cdn.faire.com/fastly/d0d3f00ba4be3cb19af0e4f212c4884960ddb5d5d81734d27e8ef92e8c2b4989.jpeg",
  ],
  priceDollars: 29.97,
  description:
    "This safe, clinically backed formula uses modern peptide technology and ancient botanicals to help balance cortisol, calm the mind, curb stress-related cravings & improve sleep – without the use of stimulants or injectables.\n\n * Helps balance cortisol levels† \n * Supports a healthy stress response and healthy adaptation to stress over time† \n * Quiets anxious feelings and tension† \n * Curbs stress-related sugar cravings and appetite & reduces stress-driven snacking† \n * Helps improve sleep quality and restfulness† \n * Promotes mental alertness and focus, while also supporting relaxation without drowsiness† \n * Stimulant-free \n * Convenient capsules ",
  tags: [],
  msrpDollars: 59.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:36.329Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
